import React from "react";
import Navbar from "../../components/shared/Navbar/Navbar";
import Footer from "../../components/shared/Footer/Footer";
import CareersBanner from "../../components/pages/Careers/CareersBanner/CareersBanner";
import OpenPositions from "../../components/pages/Careers/OpenPositions/OpenPositions";
import Culture from "../../components/pages/Careers/Culture/Culture";
import CantSee from "../../components/pages/Careers/CantSee/CantSee";

const Careers = () => {
  return (
    <div>
      <Navbar />
      <CareersBanner />
      <OpenPositions />
      <Culture />
      <CantSee />
      <Footer />
    </div>
  );
};

export default Careers;
